import { render, staticRenderFns } from "./AlertPieChart.vue?vue&type=template&id=52f71d3d&"
import script from "./AlertPieChart.vue?vue&type=script&lang=js&"
export * from "./AlertPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports